module.exports = __webpack_public_path__ + "static/media/1_graph3.01acc5ba.svg";